import { Col, Row, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import './patientDetailsFromPatientAccessCurator.css';

export default function PatientDetailsFromPatientAccessCurator(props) {

	const { formattedPacResponse, handleUpdateInfo } = props;

	return (
		<div>
			{(Object.keys(formattedPacResponse).length !== 0) ? (
				<>
					<Row className="patientDemogrphicsHeader">
						<Col>
							<h6 className="fw-bold">Found patient data</h6>
						</Col>
					</Row>
					<Row>
						<Col sm="4" className="patientDemogrphicsLabelCol">
							<p>First Name:</p>
						</Col>
						<Col>
							<p className={props.isFirstNamePacInValid ? 'invalidField' : ''}>{formattedPacResponse.firstName}</p>
						</Col>
					</Row>
					<Row>
						<Col sm="4" className="patientDemogrphicsLabelCol">
							<p>Middle Name:</p>
						</Col>
						<Col>
							<p className={props.isMiddleNamePacInValid ? 'invalidField' : ''}>{formattedPacResponse.middleName}</p>
						</Col>
					</Row>
					<Row>
						<Col sm="4" className="patientDemogrphicsLabelCol">
							<p>Last Name:</p>
						</Col>
						<Col>
							<p className={props.isLastNamePacInValid ? 'invalidField' : ''}>{formattedPacResponse.lastName}</p>
						</Col>
					</Row>
					<Row>
						<Col sm="4" className="patientDemogrphicsLabelCol">
							<p>Date Of Birth:</p>
						</Col>
						<Col>
							<p className={props.isDateOfBirthPacInValid ? 'invalidField' : ''}>{formattedPacResponse.dateOfBirth}</p>
						</Col>
					</Row>
					<Row>
						<Col sm="4" className="patientDemogrphicsLabelCol">
							<p>Gender:</p>
						</Col>
						<Col>
							<p className={props.isGenderPacInValid ? 'invalidField' : ''}>{formattedPacResponse.gender}</p>
						</Col>
					</Row>
					<Row>
						<Col sm="4" className="patientDemogrphicsLabelCol">
							<p>Address 1:</p>
						</Col>
						<Col>
							<p className={props.isAddressLine1PacInValid ? 'invalidField' : ''}>{formattedPacResponse.addressLine1}</p>
						</Col>
					</Row>
					<Row>
						<Col sm="4" className="patientDemogrphicsLabelCol">
							<p>Address 2:</p>
						</Col>
						<Col>
							<p className={props.isAddressLine2PacInValid ? 'invalidField' : ''}>{formattedPacResponse.addressLine2}</p>
						</Col>
					</Row>
					<Row>
						<Col sm="4" className="patientDemogrphicsLabelCol">
							<p>City:</p>
						</Col>
						<Col>
							<p className={props.isCityNamePacInValid ? 'invalidField' : ''}>{formattedPacResponse.cityName}</p>
						</Col>
					</Row>
					<Row>
						<Col sm="4" className="patientDemogrphicsLabelCol">
							<p>State:</p>
						</Col>
						<Col>
							<p className={props.isStateIdPacInValid ? 'invalidField' : ''}>{formattedPacResponse.state}</p>
						</Col>
					</Row>
					<Row>
						<Col sm="4" className="patientDemogrphicsLabelCol">
							<p>Zip Code:</p>
						</Col>
						<Col>
							<p className={props.isZipCodePacInValid ? 'invalidField' : ''}>{formattedPacResponse.zipCode}</p>
						</Col>
					</Row>
					<Row>
						<Col sm="4" className="patientDemogrphicsLabelCol">
							<p>Email:</p>
						</Col>
						<Col>
							<p className={props.isEmailPacInValid ? 'invalidField' : ''}>{formattedPacResponse.email}</p>
						</Col>
					</Row>
					<Row>
						<Col sm="4" className="patientDemogrphicsLabelCol">
							<p>Phone:</p>
						</Col>
						<Col>
							<p className={(props.isMobilePhonePacInValid || props.isHomePhonePacInValid || props.isAlternatePhonePacInValid) ? 'invalidField' : ''}>{formattedPacResponse.phone}</p>
						</Col>
					</Row>
					<Row>
						<Col lg="8" className="patientDemogrphicsLabelCol">
							<Button className="btn btn-primary" onClick={handleUpdateInfo}>
								<span style={{ marginRight: "10px" }}><FontAwesomeIcon icon={faArrowLeft} /></span>
								Update patient info
							</Button>
						</Col>
					</Row>
				</>
			) : (
					<>
						<Row className="patientDemogrphicsHeader">
							<Col>
								<h6 className="fw-bold">No Patient Found</h6>
							</Col>
						</Row>
						<Row style={{marginTop: "50px"}}>
							<p className="invalidField">Please update the demographics and try to validate again</p>
						</Row>
					</>
			)}
			
		</div>
	);
}